import { useIntl } from 'react-intl'

import type { TagBadgeProps } from './TagBadge.types'
import { tagColorBorder, tagColorToHex } from './tagging.utils'
import { TagPill } from './TagPill'

export const TagBadge = (props: TagBadgeProps) => {
  const { name, color, disableRemove, onRemove, onNameClick, removeDataE2e, showRemove } = props
  const intl = useIntl()

  return (
    <TagPill
      className="TagBadge"
      style={{
        backgroundColor: tagColorToHex(color),
        borderColor: tagColorBorder(color),
      }}
    >
      <span
        className={`TagBadge-name ${onNameClick ? 'TagBadge-name--clickable' : ''}`}
        onClick={onNameClick}
        onKeyDown={
          onNameClick
            ? (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  onNameClick()
                }
              }
            : undefined
        }
        role={onNameClick ? 'button' : undefined}
        tabIndex={onNameClick ? 0 : undefined}
      >
        {name}
      </span>
      {showRemove && (
        <button
          aria-label={intl.formatMessage({ id: 'Tags_remove_tag' }, { name })}
          className="TagBadge-remove"
          data-e2e={removeDataE2e}
          disabled={disableRemove}
          onClick={onRemove}
          type="button"
        >
          &#x2715;
        </button>
      )}
    </TagPill>
  )
}
